<template>
  <div class="login-page">
    <div class="login-cont container">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8 d-flex flex-column pt-4 pb-5">
          <img
            class="login-logo mx-auto my-3"
            src="https://cdn.gold549.com/build/assets/img/brand/logo.png"
            alt="GOLD 549"
            @click="$router.push('/home')"
          />

          <div class="login-header text-center">
            <h1 class="login-title">
              {{
                $store.state.language === 'en'
                  ? 'Welcome to GOLD 549!'
                  : 'GOLD 549 မှကြိုဆိုပါသည်'
              }}
            </h1>
            <p class="login-subtitle">
              {{
                $store.state.language === 'en'
                  ? 'Sign in to continue'
                  : 'အကောင့်ဝင်ရန် username နှင့် password ထည့်ပါ'
              }}
            </p>
          </div>

          <div class="card border-0 login-card">
            <div class="card-body px-lg-5 py-lg-5">
              <div v-if="error" class="login-error" role="alert">
                {{
                  $store.state.language === 'en'
                    ? 'Fail to login! Please try again.'
                    : 'အကောင့်ဝင်ခြင်း ကျဆုံးပါသည်။ တဖန်ပြန်လည် ကြိုးစားကြည့်ပါ။'
                }}
              </div>

              <form role="form" @submit.prevent="loginWithPhone">
                <div class="form-group mb-3">
                  <label class="field-label" for="login-name">
                    {{ $store.state.language === 'en' ? 'Username' : 'အသုံးပြုသူအမည်' }}
                  </label>
                  <input
                    id="login-name"
                    v-model="name"
                    class="form-control login-input"
                    type="text"
                    autocomplete="username"
                    :placeholder="
                      $store.state.language === 'en' ? 'User Name' : 'အမည် ရိုက်ထည့်ပါ'
                    "
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                  <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
                </div>

                <div class="form-group mb-3">
                  <label class="field-label" for="login-password">
                    {{ $store.state.language === 'en' ? 'Password' : 'လျို့ဝှက်နံပါတ်' }}
                  </label>
                  <div class="login-input-wrap">
                    <input
                      id="login-password"
                      ref="password"
                      v-model="password"
                      class="form-control login-input"
                      :type="isShow ? 'text' : 'password'"
                      autocomplete="current-password"
                      :placeholder="
                        $store.state.language === 'en' ? 'Password' : 'လျို့ဝှက်နံပါတ်'
                      "
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      v-if="isShow"
                      class="far fa-eye showable-password"
                      @click="showablePassword"
                    />
                    <i
                      v-else
                      class="fas fa-eye-slash showable-password"
                      @click="showablePassword"
                    />
                  </div>
                  <small v-if="errors.password" class="text-danger">{{ errors.password }}</small>
                </div>

                <div class="custom-control custom-control-alternative custom-checkbox mb-3">
                  <input
                    id="customCheckLogin"
                    class="custom-control-input"
                    type="checkbox"
                  />
                  <label class="custom-control-label" for="customCheckLogin">
                    <b>{{
                      $store.state.language === 'en'
                        ? 'Remember me'
                        : 'ဒီအကောင့်ကို မှတ်ထားပေးပါ'
                    }}</b>
                  </label>
                </div>

                <div class="text-center">
                  <button
                    type="submit"
                    class="btn btn-login my-2"
                    :disabled="isSignin"
                  >
                    <span v-if="!isSignin">
                      {{
                        $store.state.language === 'en'
                          ? 'Sign in'
                          : 'အကောင့် ဝင်မည်'
                      }}
                    </span>
                    <Loading
                      v-else
                      color="#02133e"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="d-none">
            <div
              id="forgetPassword"
              class="modal fade"
              tabindex="-1"
              role="dialog"
              aria-labelledby="modal-form"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body p-5">
                    <b>
                      Please direct contact to customer service -
                      <span class="text-danger">09756477723</span>
                    </b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      password: null,
      error: false,
      errors: {},
      isSignin: false,
      isShow: false,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    showablePassword() {
      this.isShow = !this.isShow;
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      this.error = false;
      if (!this.name) {
        this.errors.name =
          this.$store.state.language === 'en'
            ? 'Required User Name'
            : 'User name လိုအပ်ပါသည်';
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password =
          this.$store.state.language === 'en'
            ? 'Required Password'
            : 'Password လိုအပ်ပါသည်';
        this.isSignin = false;
        return false;
      }
      try {
        if (this.name === 'testuser') {
          window.open('https://about.myanmarsoccer.xyz', '_self');
        } else {
          const res = await this.axios.post(
            '/auth/login',
            {
              name: this.name,
              password: this.password,
              roles: 'normal',
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
            }
          );
          localStorage.setItem('username', this.name);
          localStorage.setItem('password', this.password);
          localStorage.setItem('token', res.data.token);

          const currentTime = new Date();
          localStorage.setItem(
            'tokenExpire',
            new Date(currentTime.getTime() + 60 * 60 * 1000)
          );
          await this.fetchUser();
          this.$router.push('/home');
          Toast.success(
            this.$store.state.language === 'en'
              ? 'Logged in!'
              : 'အကောင့်ဝင်ပြီးပါပြီ'
          );
        }
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal') {
      this.$router.push('/home');
    }
    const userName = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    if (userName && password) {
      this.name = userName;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: linear-gradient(165deg, #010d28 0%, #02133e 45%, #0a2a5c 100%);
}

.login-cont {
  padding-top: 1.5rem;
  padding-bottom: 2rem;
}

.login-logo {
  width: 120px;
  height: 120px;
  cursor: pointer;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  transition: transform 0.2s ease;
}

.login-logo:hover {
  transform: scale(1.03);
}

.login-header {
  margin-bottom: 1.25rem;
}

.login-title {
  color: #fff;
  font-size: 1.65rem;
  font-weight: 700;
  margin-bottom: 0.35rem;
}

.login-subtitle {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.95rem;
  margin-bottom: 0;
}

.login-card {
  background: #f8f9fc;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);
}

.field-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #525f7f;
  margin-bottom: 0.4rem;
}

.login-input {
  height: 46px;
  padding: 0.5rem 0.85rem;
  border: 1px solid #d1d9e6;
  border-radius: 10px;
  background: #fff;
  font-size: 1rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.login-input:focus {
  border-color: #02133e;
  box-shadow: 0 0 0 3px rgba(2, 19, 62, 0.12);
  outline: none;
}

.login-input-wrap {
  position: relative;
}

.login-input-wrap .login-input {
  padding-right: 2.5rem;
}

.showable-password {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #8898aa;
  z-index: 2;
}

.btn-login {
  width: 100%;
  max-width: 280px;
  padding: 0.75rem 1.5rem;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  color: #02133e;
  background: linear-gradient(135deg, #e8c547 0%, #d4af37 50%, #b8962e 100%);
  box-shadow: 0 4px 14px rgba(212, 175, 55, 0.45);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.btn-login:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(212, 175, 55, 0.55);
  color: #010d28;
}

.btn-login:disabled {
  opacity: 0.85;
  cursor: not-allowed;
}

.login-error {
  margin-bottom: 1rem;
  padding: 0.65rem 1rem;
  color: #c53030;
  font-weight: 600;
  font-size: 0.9rem;
  border: 1px solid rgba(197, 48, 48, 0.35);
  border-radius: 10px;
  background: rgba(197, 48, 48, 0.08);
}

.login-footer {
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.95rem;
}

.login-footer__link {
  color: #e8c547;
  font-weight: 700;
  cursor: pointer;
  margin-left: 0.35rem;
  text-decoration: none;
}

.login-footer__link:hover {
  color: #f5e6a8;
  text-decoration: underline;
}

@media (max-width: 576px) {
  .login-logo {
    width: 100px;
    height: 100px;
  }

  .login-title {
    font-size: 1.35rem;
  }
}
</style>
